import isClient from '@equifax-ui/utils/browser/isClient'
import DOMPurify from 'dompurify'

const sanitize = (content) => {
  if (isClient()) {
    return { __html: DOMPurify.sanitize(content) }
  }
}
export default sanitize
